// extracted by mini-css-extract-plugin
module.exports = {"date-range-label":"_3LeIz-","dateRangeLabel":"_3LeIz-","datetime":"_2sSjo-","date":"_1NfpV-","time":"_3gi7c-","divider":"_2qBFJ-","theme-dark":"dDUZy-","themeDark":"dDUZy-"};